import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React from 'react';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 500,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    minWidth: '100%',
    boxShadow: 'none !important',

    '& .MuiTab-wrapper':{
        display: 'flex',
        flexDirection: 'row',
        fontSize: '1.3rem',
        fontWeight: 500
    },
    '& .MuiTab-labelIcon':{
        minHeight: "60px"
    },
    '& .MuiTabs-indicator':{
        display: 'none'
    },
    '& .MuiButtonBase-root':{
        backgroundColor: '#eee',
    },
    '& .Mui-selected':{
        backgroundColor: '#fff',
        borderTop: '1px solid #27272F',
        borderRight: '1px solid #27272F',
        borderLeft: '1px solid #27272F',
    }
  },
});

export default function CustomTabs(props) {
  const classes = useStyles();

  return (
    <Paper square className={classes.root}>
      <Tabs
        value={props.value}
        onChange={props.handleChange}
        variant="fullWidth"
        indicatorColor="secondary"
        textColor="secondary"
        aria-label="icon label tabs example"
      >
        {
            props.tabs.map((item, index) => {
                return(
                <Tab key={index} icon={<img src={item.src} style={{marginRight: 5}} />} label={item.label} />
                )
            })
        }
      </Tabs>
    </Paper>
  );
}
